import { FC, useCallback, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import AddBoxSharpIcon from '@mui/icons-material/AddBoxSharp';
import LoadImageIcon from '@mui/icons-material/Visibility';
import theme from 'App.theme';
import { StyledIconButton, TrayImageBox } from '../CheckInOutPage.styles';
import { useLanguage } from 'context/AppContext';
import Box from '@mui/material/Box';

type TTrayImage = FC<{
  imageUrl?: string;
  imageAlt?: string;
  width?: string;
  height?: string;
  disabled?: boolean;
  editable?: boolean;
  preCapture?: boolean;
  showPlaceholder?: boolean;
  onClick?: VoidFunction;
}>;

const TrayImage: TTrayImage = ({
  imageUrl = '',
  imageAlt = '',
  width,
  height,
  editable = false,
  preCapture = false,
  showPlaceholder = true,
  onClick,
}) => {
  const lang = useLanguage()[0].TraySummary;

  const [showCloseIcon, setShowCloseIcon] = useState<boolean>(false);

  const trayImageBoxRef = useRef<HTMLButtonElement | null>(null);

  const handleClick = useCallback(() => {
    onClick?.();

    if (!imageUrl) return;

    // toggle image size
    const el = trayImageBoxRef.current;
    if (!el) return;
    const isLarge = el.classList.contains('large-image');
    if (isLarge) el.classList.remove('large-image');
    else el.classList.add('large-image');

    // remove or add the close icon
    setShowCloseIcon(!isLarge);
  }, [imageUrl, onClick]);

  const Icon = preCapture ? AddBoxSharpIcon : LoadImageIcon;

  return (
    <TrayImageBox
      width={width}
      height={height}
      ref={trayImageBoxRef}
      className={editable ? 'add-image-icon' : ''}
      onClick={handleClick}
    >
      {imageUrl ? (
        <>
          <img
            className="tray-image"
            //style={{ display: 'none' }}
            //onLoad={e => e.currentTarget.style.display = 'block'}
            src={imageUrl}
            alt={imageAlt}
          />

          {showCloseIcon && (
            <StyledIconButton onClick={() => handleClick}>
              <CloseIcon />
            </StyledIconButton>
          )}
        </>
      ) : showPlaceholder ? (
        <Box className="tray-image-placeholder">
          <Box className="placeholder-label">
            <Box style={{ color: editable ? theme.colors.black : theme.greys.GREY0 }}>
              {preCapture ? lang.captureImage : lang.loadImage}
            </Box>
            <Icon
              sx={{
                color: editable ? theme.colors.active : theme.greys.GREY0,
                width: '64px',
                height: '64px',
                position: 'relative',
              }}
            />
          </Box>
        </Box>
      ) : null}
    </TrayImageBox>
  );
};

export default TrayImage;
